// extracted by mini-css-extract-plugin
export default {"root":"IconShow_root__m3uhJ"};